import {
  ChangeDetectorRef,
  DestroyRef,
  inject,
  Pipe,
  PipeTransform,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslationCoreService } from '@qtek/libs/translation-core';
import { Column } from '@qtek/shared/models';

@Pipe({ name: 'columnHeader', pure: false })
export class ColumnHeaderPipe implements PipeTransform {
  private readonly translateService = inject(TranslationCoreService);
  private readonly cdr = inject(ChangeDetectorRef);

  private cache: Map<string, string> = new Map();

  constructor() {
    this.translateService.translationsOrLang$
      .pipe(takeUntilDestroyed(inject(DestroyRef)))
      .subscribe(() => {
        this.cache.clear();
        this.cdr.markForCheck();
      });
  }

  transform(column: Column): string {
    if (!column.label) {
      return column.description || '';
    }
    if (column.disableTranslate) {
      return column.label;
    }
    const key = column.label;
    const cached = this.cache.get(key);
    if (cached !== undefined) {
      return cached;
    }
    const value = this.translateService.instant(column.label);
    this.cache.set(key, value);
    return value;
  }
}
